import { Component, OnInit, Input, ɵCompiler_compileModuleSync__POST_R3__ } from '@angular/core';
import { ProjectFacilityAnnualOperatingPlanApi } from 'src/app/services/permit-project-facility-aop.service';
import { PermitSubmitStatusService } from 'src/app/services/permit-submit-status.service';

@Component({
  selector: '[app-project-facility-status-group]',
  templateUrl: './project-facility-status-group.component.html',
  styleUrls: ['./project-facility-status-group.component.scss']
})
export class ProjectFacilityStatusGroupComponent implements OnInit {

  @Input() pfaop: ProjectFacilityAnnualOperatingPlanApi;

  overallStatus: string = "empty";
  locationStatus: string = "empty";
  partnerStatus: string = "empty";
  instrumentStatus: string = "empty";

  constructor(private permitSubmitStatusService: PermitSubmitStatusService ) { }

  ngOnInit() {
    if (this.pfaop.annualMaxCapacityForAllDiversionsAF) {
      this.locationStatus = "complete";
    }
    if (this.pfaop.hasSponsors && this.pfaop.projectFacilitySponsorApiList.length > 0) {
      if (typeof this.pfaop.projectFacilitySponsorApiList[0].payingEntityName !== "undefined") {
        if (this.pfaop.projectFacilitySponsorApiList[0].payingEntityName !== null) {
          if (this.pfaop.projectFacilitySponsorApiList[0].payingEntityName.length) {
            this.partnerStatus = "complete";
          }
        }
      }
    } else if (this.pfaop.hasSponsors === false) {
      this.partnerStatus = "complete";
    } else {
      this.partnerStatus = "empty";
    }

    if (this.pfaop.hasInstrumentation && this.pfaop.projectFacilityInstrumentApiList.length > 0) {
      if (typeof this.pfaop.projectFacilityInstrumentApiList[0].name !== "undefined") {
        if (this.pfaop.projectFacilityInstrumentApiList[0].name !== null) {
          if (this.pfaop.projectFacilityInstrumentApiList[0].name.length) {
            this.instrumentStatus  = "complete";
          }  
        }
      }  
    } else if (this.pfaop.hasInstrumentation === false) {
      this.instrumentStatus = "complete";
    } else {
      this.instrumentStatus = "empty";
    }

    if (this.locationStatus === "complete" && this.partnerStatus === "complete" && this.instrumentStatus === "complete") {
      this.overallStatus = "complete";
      this.permitSubmitStatusService.changePermitAnnualOperatingPlanStatus(true);
    } else if (this.locationStatus === "complete" || this.partnerStatus === "complete" || this.instrumentStatus === "complete") {
      this.overallStatus = "started";
      this.permitSubmitStatusService.changePermitAnnualOperatingPlanStatus(false);
    } else {
      this.overallStatus = "empty";
      this.permitSubmitStatusService.changePermitAnnualOperatingPlanStatus(false);
    }
  }

}
